import React, { useState, useEffect, useRef } from 'react';
import CMSService from "services/CMS";
import PubSub from "services/PubSub";
import LoginService from "services/Login";
import ItemStore from './ItemStore';
import ItemAddress from './ItemAddress';
import AddressService from "services/Address";
import AddressFactory from "factories/Address";
import Loader from "components/Loader";
import StorageService from 'services/StorageService';
import { actionsType } from 'config/constants';
import PropTypes from 'prop-types';
import TagManagerService from 'services/TagManager';
import warning from 'images/icons/warning.svg';
import { modalDeliverySelectorTxt } from 'config/translate/variables';
import style from './style.scss';//NOSONAR

let actions = [];

const DeliverySelector = ({settings}) => {
    const [tab, setTab] = useState(false);
    const [stores, setStores] = useState(null);
    const [addresses, setAddresses] = useState(null);
    const [storeSelected, setStoreSelected] = useState(null);
    const [addressSelected, setAddressSelected] = useState(null);
    const [isLoadingAddress, setIsLoadingAddress] = useState(false);
    const [isLoadingStores, setIsLoadingStores] = useState(false);
    const [isLogged, setIsLogged] = useState(false);
    const [notScMessage, setNotScMessage] = useState(false);
    const [notDisponibleMessage, setNotDisponibleMessage] = useState(false);
    const scrollerStore = useRef();
    const scrollerAddress = useRef();
    useEffect(() => {

        actions.push(PubSub.register('address_updated', updateAddress));

        _getAddress();
        _getCurrent();
        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];

        }
    }, []);
    useEffect(()=> {

    },[settings])

    useEffect(()=> {
        setNotDisponibleMessage(false);
        setNotScMessage(false);
    },[storeSelected, addressSelected, tab]);


    const selectStore = (store, method) => {
        store.method = method;
        setStoreSelected({...store});
    }

    const updateAddress = () => {
        _getAddress();
    }

    const selectAddress = (add) => {
        setAddressSelected({...add})
    }

    const _getDeliveryType = (type, text = false) => {
        switch (type) {
            case "seller-1-sla-ClickalAuto":
                return text ? 'auto' : 2

            case 'seller-1-sla-RetiroenTienda':
                return text ? 'store' : 1

            case 'seller-1-sla-DespachoaDomicilio':
                return text ? 'home' : 0

            case "Jumbo Chile":
                return text ? 'home' : 3

            case 'seller-1-sla-Express':
                return text ? 'express' : 3
            default:
                StorageService.setItem('store_name', 'Jumbo Chile');
                return  0
        }
    }
    const _getAddressDefault = () => {
        const address = StorageService.getSecureItem('address');

        if(address){
            delete address.geoCoordinates;
            const objAddress = AddressFactory.getAdressesOptions([address])[0];
            return objAddress;
        }
        else{
            return null;
        }
    }

    const _getCurrent = () => {
        let firstSelection = {};

        const deliveryType = _getDeliveryType(AddressService.getDeliveryMode());
        const deliveryTypeText = _getDeliveryType(AddressService.getDeliveryMode(), true);
        const storeName = StorageService.getItem('store_name');

        if(deliveryType === 0 || deliveryType === 3){

            const objAddress = _getAddressDefault();
            setTab(false);
            selectAddress(objAddress);

        } else if (deliveryType === 1 || deliveryType === 2){
            setTab(true)
            firstSelection = {
                name: storeName,
                method: deliveryTypeText
            }
        }

        setIsLoadingStores(true);
        CMSService.getOperationsV2().then(data => {
            if (!data) {
                data = {};
            }
            let newStoreSelected = data.store.filter((store) => store.name === firstSelection.name)[0];

            let st = data.store ? data.store.filter(store => store.active) : [];
            if(newStoreSelected && firstSelection.name){
                newStoreSelected.method = firstSelection.method;
                setStoreSelected(newStoreSelected);
                st = st.map((store) => {
                    if(store.value == newStoreSelected.value) return false;
                    store.saved = false;
                    return store;
                }).filter(Boolean);

                newStoreSelected.saved = true;
                st = new Array(newStoreSelected).concat(st);
            }

            setStores([...st]);
            setIsLoadingStores(false);
        });
    }

    const openAddressModal = () => {
        PubSub.dispatch('address_open', {
            address: null
        });
    }

    const filterStores = (ev) => {

        const value = ev.currentTarget ? ev.currentTarget.value.toUpperCase() : '';

        const ul = document.getElementById("list-stores");
        const li = ul.getElementsByTagName('li');
        for (let i = 0; i < li.length; i++) {
            const title = li[i].getElementsByTagName("span")[0];
            const address = li[i].getElementsByTagName("span")[1];
            const txtValue = (title.textContent +' '+  address.textContent) || (title.innerText +' '+ address.innerText);

            if (txtValue.toUpperCase().indexOf(value) > -1) {
                li[i].style.display = "";
            } else {
                li[i].style.display = "none";
            }
        }
    }

    const _getAddress = () => {
        const token = LoginService.getUserToken();
        setIsLoadingAddress(true);
        if (token) {
            if (!isLoadingAddress) {
                setIsLogged(!!token);
            }
            AddressService.getAll(token).then(adresses => {
                let listAddress=AddressFactory.getAdressesOptions(adresses);

                const address = _getAddressDefault();
                const deliveryType = _getDeliveryType(AddressService.getDeliveryMode());

                if(address && (deliveryType === 0 || deliveryType === 3)){
                    listAddress = listAddress && listAddress.map((add) => {
                        if(add.value.addressId == address.value.addressId) return false;
                        add.saved = false;
                        return add;
                    }).filter(Boolean);

                    address.saved = true;
                    listAddress = new Array(address).concat(listAddress);
                    selectAddress(address);

                }
                setAddresses(listAddress);
                setIsLoadingAddress(false);
            }).catch(() => setIsLoadingAddress(false));
        } else {
            const adresses = AddressService.getAnonymousAdresses();
            if (adresses) {
                setAddresses(AddressFactory.getAdressesOptions(adresses));
            }
            setIsLoadingAddress(false);
        }
    }

    let initialX = null;
    const startTouch = (e) => {
        initialX = e.touches[0].clientX;
    };

    let diffX = '';
    const moveTouch = (e) => {
        if (initialX === null) return false;

        const currentX = e.touches[0].clientX;
        diffX = initialX - currentX;
    };

    const touchFinish = () => {
        if (diffX) {
            if (diffX > 36) {
                setTab(true)
            }
            if (diffX < -36) {
                setTab(false)
            }
        }
    }

    const _close = (callback = false) =>  {
        if(callback && settings && settings.successCallback) settings.successCallback();

        setTimeout(() => PubSub.dispatch(actionsType.MODAL.DELIVERY_SELECTOR_CLOSE),0);
    }

    const goLogin = () => {
        _close();

        PubSub.dispatch('login_open');
    }

    const goRegister = () => {
        _close();
        PubSub.dispatch('register_open');
    }

    const _applyDelivery = (sc, method, name, nameMethod, selectedAddress = null, simulation = true) =>{

        const responsePromise = {
            data: {
                isDisponible: true
            }
        }

        let consult = simulation ? AddressService.getLogisticSimulation(selectedAddress, sc, nameMethod) : Promise.resolve(responsePromise);

        return consult.then(data => {

            if(data.data && data.data.isDisponible){
                return AddressService.newSetDeliveryMode(method, name, sc, true, selectedAddress).then((orderForm)=>{
                    _close();
                    return orderForm;
                });
            } else {
                setNotScMessage(false);
                if(tab){
                    blockedStore();
                }else{
                    blockedAddress();
                }
                setNotDisponibleMessage(true);
            }
            setIsLoadingAddress(false);
            setIsLoadingStores(false);

        }).catch(()=>{
            setIsLoadingAddress(false);
            setIsLoadingStores(false);
        });
    }
    const blockedStore = () => {
        let newStore = stores && stores.map((store) => {

            if(storeSelected && (store.name == storeSelected.name)){
                store.disabled = true;
            }

            return store
        });

        setStores([...newStore]);
    }
    const blockedAddress = () => {
        let newAddresses = addresses && addresses.map((address) => {

            if((addressSelected && addressSelected.value) && (address.value.addressId == addressSelected.value.addressId)){
                address.disabled = true;
            }

            return address;
        });
        setAddresses(newAddresses);
    }
    const submit = () => {
        let method = "seller-1-sla-DespachoaDomicilio";
        let name = '';
        let sc = 11;
        let nameMethod  = '';
        let selectedAddress = '';

        if(tab){

            switch(storeSelected.method){
                case 'store':
                    method = "seller-1-sla-RetiroenTienda";
                    name = storeSelected.value;
                    sc = storeSelected.sc;
                    TagManagerService.changeDeliveryMode('retiro en local: ' + name);
                    nameMethod = 'Retiro en Tienda';
                    break;

                case 'auto':
                    method = "seller-1-sla-ClickalAuto";
                    name = storeSelected.value;
                    sc = storeSelected.sc;
                    TagManagerService.changeDeliveryMode('retiro en auto: ' + name);
                    nameMethod = 'Click al Auto';
                    break;
            }
        } else {
            if(addressSelected && addressSelected.value){
                selectedAddress = addressSelected.value;
                name = selectedAddress.neighborhood;
                TagManagerService.receiveHome(selectedAddress.street + ' ' + '' + selectedAddress.number + ' ' + '' + selectedAddress.neighborhood + ' ' + '' + selectedAddress.city + ' ' + '' + selectedAddress.state);
                nameMethod = 'Despacho a Domicilio';
            }

        }

        if(!tab){
            if(scrollerAddress){
                scrollerAddress.current.scrollTo({top: 0, behavior: 'smooth'});
            }
            setIsLoadingAddress(true);
            if(addressSelected && selectedAddress.geoCoordinate){
                AddressService.getSalesChannel(selectedAddress.geoCoordinate[1], selectedAddress.geoCoordinate[0]).then(salesChannel => {
                    if (salesChannel.sc) {
                        sc = salesChannel.sc;
                        selectedAddress.geoCoordinates = selectedAddress.geoCoordinate;
                        _applyDelivery(sc, method, name, nameMethod, selectedAddress);
                    } else {
                        setNotScMessage(true);
                        setIsLoadingAddress(false);
                    }
                });
            }else{
                setIsLoadingAddress(false);
            }
        }else{
            if(scrollerStore){
                scrollerStore.current.scrollTo({top: 0, behavior: 'smooth'});
            }
            setIsLoadingStores(true);
            _applyDelivery(sc, method, name, nameMethod, false);
        }
    }

    const buttonsLogin = () => {
        return (<div className="delivery-selector-actions">
            <button type="button" className="flat-btn btn-link" onClick={goRegister}>
                Regístrate
            </button>
            <button type="submit" className="flat-btn btn-link" onClick={goLogin}>
                Ingresa
            </button>
        </div>)
    }

    return (
        <div className="delivery-selector-content new-modal-container">
            <div className="new-modal-scroll">
                <span className="delivery-selector-title">{modalDeliverySelectorTxt.title}</span>
                <div className="delivery-selector-container">
                    <div className="delivery-selector-tabs titles">
                        <div className={"delivery-type-tab-title" + (!tab ? ' active' : '')} onClick={() => setTab(false)} onTouchStart={startTouch} onTouchMove={moveTouch} onTouchEnd={touchFinish}>
                            Despacho
                        </div>
                        <div className={"delivery-type-tab-title" + (tab ? ' active' : '')} onClick={() => setTab(true)} onTouchStart={startTouch} onTouchMove={moveTouch} onTouchEnd={touchFinish}>
                            Retiro
                        </div>
                    </div>

                    <div className={"delivery-selector-tabs" + ((isLoadingAddress || isLoadingStores) ? ' not-scrolling' : '')}>
                        <div ref={scrollerAddress} className={"delivery-type-tab-content delivery" + (!tab ? ' active' : '')} onTouchStart={startTouch} onTouchMove={moveTouch} onTouchEnd={touchFinish}>
                            <ul id="list-address">
                                {isLoadingAddress && <span className="loader-list-wrap"><Loader/></span>}
                                {addresses && addresses.map((address, i) => {
                                    return <ItemAddress address={address} addressSelected={addressSelected} customOnClick={selectAddress} key={i}/>
                                })}
                            </ul>

                            {((!addresses || !addresses.length) && !isLoadingAddress) && <div className="delivery-selector-msg-wrap">
                                {((!addresses || !addresses.length) && !isLoadingAddress) && <span className="delivery-selector-not-addresses">Aún no tienes direcciones guardadas{!isLogged && ', '}
                                    {!isLogged && <span className="delivery-selector-create-address"><a onClick={openAddressModal}>crea una dirección</a> o ingresa a tu cuenta</span>}</span>}
                                {(!isLogged && (!addresses || !addresses.length) && !isLoadingAddress) && buttonsLogin()}
                                {((!addresses || !addresses.length) && !isLoadingAddress && isLogged) && <button className={'flat-btn delivery-selector-address-add-btn'} onClick={openAddressModal}>Agregar dirección</button>}
                            </div>}

                            {addresses && !!addresses.length && <button className={'flat-btn delivery-selector-address-add-btn'} onClick={openAddressModal}>Agregar dirección</button>}
                        </div>
                        <div ref={scrollerStore} className={"delivery-type-tab-content withdraw" + (tab ? ' active' : '')} onTouchStart={startTouch} onTouchMove={moveTouch} onTouchEnd={touchFinish}>
                            <input type="text" className="filter-store-input" placeholder="¿Qué local buscas?" onChange={(val) => filterStores(val)}/>
                            <ul id="list-stores">
                                {isLoadingStores && <span className="loader-list-wrap"><Loader/></span>}
                                {stores && stores.map((store, i) => {
                                    return <ItemStore store={store} storeSelected={storeSelected} customOnClick={selectStore} key={i}/>
                                })}
                            </ul>
                            <div>
                                {((!stores || !stores.length) && !isLoadingStores) && <div dangerouslySetInnerHTML={{ __html: warning }} className="wrap-warning-icon"/>}
                                {((!stores || !stores.length) && !isLoadingStores) && <span className="delivery-selector-not-addresses">Temporalmente sin cobertura</span>}
                            </div>

                        </div>

                    </div>

                </div>
            </div>
            {(notDisponibleMessage && !tab) && <div className='delivery-selector-error-msg'>{modalDeliverySelectorTxt.noWindows}<br/>{modalDeliverySelectorTxt.tryLater}</div>}
            {(notDisponibleMessage && tab) && <div className='delivery-selector-error-msg'>{modalDeliverySelectorTxt.storeUnavailable}</div>}
            {(notScMessage && !tab) && <div className='delivery-selector-error-msg'>{modalDeliverySelectorTxt.noCoverage}</div>}

            <div className={"modal-actions"}>
                <span className="btns-actions-delivery">
                    <button className="secundary-btn delivery-selector-btn"  onClick={_close}>Cancelar</button>
                    { <button className="primary-btn delivery-selector-btn" disabled={(tab && (!(storeSelected && storeSelected.method) || isLoadingStores)) || (!tab && (!(addressSelected && addressSelected.value) || isLoadingAddress))} onClick={submit}>{modalDeliverySelectorTxt.btnSubmit}</button>}
                </span>
            </div>
        </div>)
}

DeliverySelector.propTypes = {
    settings: PropTypes.object
};

export default DeliverySelector;
